const initialState = { };

export const actionCreators = {
    
};

export const reducer = (state, action) => {
    state = state || initialState;
    /*
    if (action.type === loadProjects) {
        return { ...state, projects: action.result, isInLoading: false };
    }
    */
    return state;
};
